import { colors } from './tokens';

export const getStatusForeground = (status: string): string => {
  switch (status) {
    case 'reviewed':
      return colors.status.success;
    case 'in-progress':
      return colors.status.warning;
    case 'edited':
      return colors.status.info;
    default:
      return colors.status.neutral;
  }
};

export const getStatusBackground = (status: string): string => {
  switch (status) {
    case 'reviewed':
      return colors.backgroundTones.success;
    case 'in-progress':
      return colors.backgroundTones.warningSoft;
    case 'edited':
      return colors.backgroundTones.infoBright;
    default:
      return colors.backgroundTones.neutral;
  }
};
